<template>
  <div class="form-group">
    <label :for="'templateOption_' + templateOption.name">{{ templateOption.label }}</label>
    <div v-if="templateOption.type === 'radio'">
      <div class="form-check form-check-inline" v-for="option in templateOption.options">
        <input class="form-check-input" type="radio"
               :name="'templateOption['+ templateOption.name + ']'"
               :id="'templateOption_' + templateOption.name + '_' + option.value"
               v-model="optionValue"
               :value="option.value">
        <label class="form-check-label"
               :for="'templateOption_' + templateOption.name + '_' + option.value">{{ option.label }}</label>
      </div>
    </div>
    <template v-else-if="templateOption.type === 'select'">
      <Combobox
        :id="'templateOption_' + templateOption.name"
        :name="'templateOption['+ templateOption.name + ']'"
        v-model="optionValue"
        :options="templateOption.options.map(option => ({
          value: option.value,
          label: option.label
        }))"
        :fullwidth="true"
      />
    </template>
  </div>
</template>

<script>
import Combobox from "@/components/ui/Combobox.vue";

export default {
  components: {
    Combobox
  },
  props: {
    templateOption: {
      type: Object,
      required: true
    },
    modelValue: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      optionValue: this.modelValue || this.templateOption.default
    }
  },
  watch: {
    optionValue: function (value) {
      // console.log('TemplateOption: optionValue changed', value)
      this.$emit('update:modelValue', {
        name: this.templateOption.name,
        value: value
      })
    }
  }
}
</script>

<style scoped>

</style>
